import { AppConfig } from 'types';
import { CreateProcessFlowTypeNumber } from 'helpers';
import { Endpoints, FlowType } from 'consts';
import { UserState } from 'store/state';

export function QueryString(params: Record<string, any>) {
	const nonEmpty = Object.keys(params).reduce((map: Record<string, any>, key) => {
		if (params[key]) map[key] = params[key];
		return map;
	}, {});
	const searchParams = new URLSearchParams(nonEmpty).toString();
	return `?${searchParams}`;
}

export function ProductsURL(API: Endpoints, processId: string, isExternal: boolean) {
	const qs = `externalCreditCheck=${isExternal ? 'true' : 'false'}`;
	return `${API.products}/${processId}/GetProducts?${qs}`;
}

export function RelationsURL(config: AppConfig, user: UserState, flowType: FlowType) {
	const { API, IS_EMPLOYEE_WEB } = config;
	const { companyKennitala, isManualSignCompany, kennitala } = user;
	const flowTypeNumber = CreateProcessFlowTypeNumber(flowType);
	const ssn = IS_EMPLOYEE_WEB && isManualSignCompany && companyKennitala ? `&companyssn=${companyKennitala}` : '';
	const qs = `?flowType=${flowTypeNumber}&ssn=${kennitala}${ssn}`;
	return API.getIndividualAndCompaniesInfo + qs;
}
